import { useGetOrganizationQuery } from "../store/apiSlice/accountApiSlice";

/**
 * True when org Financial Settings allow Authorised/Paid prepayment updates in Orderlink.
 *
 * Prepayments are not pushed to Xero yet, so a missing source defaults to Orderlink.
 */
export const usePaymentStatusManagedInOrderlink = () => {
  const { data } = useGetOrganizationQuery();
  const source = data?.operation_preference?.payment_status_source?.id;
  if (!source) return true;
  return source === "orderlink";
};
